var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('cell',{staticClass:"z-20 sticky top-0",attrs:{"background":'bg-gray-100 dark:bg-gray-600'}},[_c('span',{domProps:{"innerHTML":_vm._s(_vm.column.header)}})])}
var staticRenderFns = []

export { render, staticRenderFns }